import { render } from "./CategoryDetails.vue?vue&type=template&id=c305076a&ts=true"
import script from "./CategoryDetails.vue?vue&type=script&lang=ts"
export * from "./CategoryDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__